import * as React from 'react';
import { useStyletron } from 'baseui';
import { FileUploader } from 'baseui/file-uploader';
const FileUpload = ({
  handleUpload,
  disabled = false,
  multiple = false,
  overrides
}) => {
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isUploading, setIsUploading] = React.useState(false);
  const [css] = useStyletron();
  function reset() {
    setIsUploading(false);
  }
  function startProgress() {
    setIsUploading(true);
  }
  return <div className={css({
    margin: '1em 0'
  })} data-testid="file-upload">
      <FileUploader onCancel={reset} onDrop={(acceptedFiles, rejectedFiles) => {
      startProgress();
      handleUpload(acceptedFiles[0]).then(() => {
        reset();
      }).catch(err => {
        setErrorMessage(err.message);
        reset();
      });
    }} errorMessage={errorMessage} progressMessage={isUploading ? `Uploading... hang tight.` : ''} disabled={disabled} multiple={multiple} overrides={overrides} />
    </div>;
};
export default FileUpload;